import React from 'react';

const STATUS_STYLES = {
  Open: 'bg-green-100 text-green-800',
  Closed: 'bg-gray-100 text-gray-600',
  Pending: 'bg-yellow-100 text-yellow-800',
  'On Hold': 'bg-orange-100 text-orange-700',
  Active: 'bg-green-100 text-green-800',
  Inactive: 'bg-gray-100 text-gray-600',
  Draft: 'bg-gray-100 text-gray-600',
  Sent: 'bg-blue-100 text-blue-700',
  Paid: 'bg-green-100 text-green-800',
  'Partially Paid': 'bg-teal-100 text-teal-700',
  Overdue: 'bg-red-100 text-red-700',
  Cancelled: 'bg-gray-100 text-gray-500',
  High: 'bg-red-100 text-red-700',
  Medium: 'bg-orange-100 text-orange-700',
  Low: 'bg-blue-100 text-blue-700',
  Unbilled: 'bg-yellow-100 text-yellow-800',
  Billed: 'bg-green-100 text-green-800',
  'Written Off': 'bg-gray-100 text-gray-600',
  'Not Started': 'bg-gray-100 text-gray-600',
  'In Progress': 'bg-blue-100 text-blue-700',
  Completed: 'bg-green-100 text-green-800',
  Deposit: 'bg-green-100 text-green-800',
  Withdrawal: 'bg-red-100 text-red-700',
  Cleared: 'bg-green-100 text-green-800',
  'Conflict Found': 'bg-red-100 text-red-700',
};

export default function StatusBadge({ status }) {
  const style = STATUS_STYLES[status] || 'bg-gray-100 text-gray-600';
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${style}`}>
      {status}
    </span>
  );
}
